export default __webpack_public_path__ + "static/media/roadside-assistance-banner.613f866e.jpg";